import axios from 'axios';
import { useState, useEffect } from 'react';
import { Link as NavLink } from 'react-router-dom';
import { Pagination, TextField, PaginationItem } from '@mui/material'
import Skeleton from '../Main/Skeleton'
import Categories from '../Categories'

const BASE_URL = 'http://wiki2.promoshoko.ru/wp-json/wp/v2/posts?';
// const BASE_URL_CAT = 'http://wiki.promoshoko.ru/wp-json/wp/v2/categories/';

const Main = () => {
    
    const history = window.location.search;//получаем id страницы ?page=id
    const [post, setPost] = useState([]);
    const [search, setSearch] = useState('');
    // const [page, setPage] = useState(1);
    const [page, setPage] = useState(parseInt(history?.split('=')[1] || 1));
    const [pageQty, setPageQty] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [categoryId, setCategoryId] = useState( localStorage.getItem('category') === '' ? true : localStorage.getItem('category') );

    useEffect(() => {
      setIsLoading(true)
  
      axios.get(BASE_URL , {
        params: {
          search: search,
          page: page,
          categories: categoryId,
        }
      })
      //&categories=${categoryId}
      .then(({data, headers}) => {
        // let totalPosts = data.headers["x-wp-total"];
        let totalPages = headers["x-wp-totalpages"];

        setPost(data)
        setPageQty(parseInt(totalPages))
        setIsLoading(false)

        //переход на первую страницу при клике
        if(totalPages < page){
          setPage(1);
        }
        let url = document.querySelector('header nav li a.active');
        url.onclick = function() {
          setPage(1);
        }

      })
      .catch(function (error) {
        console.log(error);
      });

    }, [search, page, categoryId]);

    return (
      <div className='flex --top'>
        <div className='col-8'>
          <h1>Главная</h1>
          <div>
            <TextField
              variant="standard"
              fullWidth
              label="Поиск по сайту"
              value={search}
              // контролируемый инпут
              onChange={(event) => setSearch(event.target.value)} 
            />
            {isLoading
              ? [...new Array(10)].map((_, index) => <Skeleton key={index}/>)
              : post.map(post => (
                <div className='flex' key={post.id}>
                  <NavLink to={`/news/${post.id}`}>
                    <h3>{post.title.rendered}</h3>
                  </NavLink>
                  {/* <span>#{post.categories[0]}</span> */}
                  {  
                    // taxonomy.map((props, index) =>()
                    // cat.map((cat, index) => (
                    //   <span key={cat.toString()}>{cat}</span>
                    //   // <li key={index}><NavLink to={`/`}>{cat} - {index}</NavLink></li>
                    // ))
                    // cat.map((cat, index) => 
                    //   // console.log(post.categories[0])
                    //   cat.id === post.categories[0]
                    //   ? cat.name
                    //   : '', {}
                    // )
                  }
                </div>
              ))
            }

            {!!pageQty && (
                <Pagination
                  count={pageQty}
                  shape="rounded"
                  page={page}
                  onChange={(_, num) => setPage(num)}
                  showFirstButton
                  showLastButton
                  sx={{marginY: 3, marginX: 'auto', maxWidth: 860}}
                  renderItem={
                    (item) => (
                      <PaginationItem
                        component={NavLink}
                        to={`/?page=` + (item.page)}
                        {...item}
                      />
                    ) 
                  }
                />
            )}

            {/* {
              post.map(post => (
                <Link key={post.id} to={`/news/${post.id}`}>
                  <div className='flex'>
                    <h3>{post.title.rendered}</h3><span>#{post.categories.rendered}</span>
                  </div>
                </Link>
              ))
            } */}
          </div>
        </div>
        <div className='col-4 p-2'>
          {/* <Categories value={categoryId} onClickCategory={(i)=> setCategoryId(i)}/>    */}
          <Categories value={categoryId} onClickCategory={(id)=> setCategoryId(id)}/>
        </div>
      </div>
    );
  }
  
  export default Main;